export const ROOT = 'root'
export const LOGIN = 'login'
export const VIEW = 'view'

export const APP = 'app'
export const APP_MANAGE = 'app-manage'
export const APP_DETAIL = 'APP_DETAIL'

export const WORKSPACE_CONTAINER = 'workspace-container'
export const WORKSPACE = 'workspace'
export const WORKSPACE_DETAIL = 'workspace-detail'
export const APP_CONFIG = 'app-config'
export const BASIC_INFORMATION = 'basic-information'
export const ENV = 'env'
export const ENV_LIST = 'env-list'
export const ENV_DETAIL = 'env-detail'
export const PUBLISH_CONFIG = 'publish-config'
export const PUBLISH_CONFIG_LIST = 'publish-config-list'
export const PUBLISH_DETAIL = 'publish-detail'
export const CLOUD_ASSISTANT = 'cloud-assistant'

export const APP_RESOURCE = 'app-resource'
export const OBJECT = 'object'
export const OBJECT_LIST = 'object-list'
export const OBJECT_DETAIL = 'ObjectDetail'
export const SERVICE_MANAGEMENT = 'service-management'
export const STAR_MAP = 'star_map'
export const APP_OPERATION = 'app_operation'
export const APP_TENANT  = 'app_tenant'
export const FAST_TRACKER = 'fast_tracker'
export const TENANT_LIST  = 'tenant_list'
export const PERMISSION_LIST = 'PERMISSION_LIST'

export const RESOURCE = 'resource'
export const DEPLOYMENT_ENVIRONMENT = 'deployment-environment'
export const DEPLOYMENT_ENVIRONMENT_LIST = 'deployment-environment-list'
export const DEPLOYMENT_ENVIRONMENT_DETAIL = 'deployment-environment-detail'

export const COMPONENT_PACKAGE = 'component-package'
export const COMPONENT_PACKAGE_LIST = 'component-package-list'
export const COMPONENT_PACKAGE_DETAIL = 'component-package-detail'
export const COMPONENT_PACKAGE_DETAIL_INDEX = 'component-package-detail-index'
export const COMPONENT_DETAIL = 'component-detail'

export const COMPONENT_GROUPING = 'component-grouping'
export const COMPONENT_GROUPING_LIST = 'component-grouping-list'
export const COMPONENT_GROUPING_DETAIL = 'component-grouping-detail'

export const MEMBER = 'member'
export const HELP = 'help'
export const MIDDLE_PAGE = 'MIDDLE_PAGE'

export const SECRET = 'secret'
